import styled from 'styled-components';

const Disc = styled.span<{ $size: number; $bg: string }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: ${({ $bg }) => $bg};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const Dash = styled.span<{ $color: string; $width: number }>`
  width: ${({ $width }) => $width}px;
  height: 2px;
  border-radius: 2px;
  background: ${({ $color }) => $color};
`;

export function PlayDisc({
  size = 28,
  playing = false,
}: {
  size?: number;
  playing?: boolean;
}) {
  const glyph = Math.round(size * 0.34);
  return (
    <Disc $size={size} $bg="var(--tm-navy)" aria-hidden="true">
      <svg width={glyph} height={glyph} viewBox="0 0 10 10" aria-hidden="true">
        {playing ? (
          <path d="M2 1h2.2v8H2zM5.8 1H8v8H5.8z" fill="#FFFFFF" />
        ) : (
          <path d="M2.5 1 9 5l-6.5 4z" fill="#FFFFFF" />
        )}
      </svg>
    </Disc>
  );
}

export function BackDisc() {
  return (
    <Disc $size={32} $bg="var(--tm-navy-tint)" aria-hidden="true">
      <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
        <path d="M7 1 2 5l5 4z" fill="#032170" />
      </svg>
    </Disc>
  );
}

export function CheckDisc() {
  return (
    <Disc $size={20} $bg="#FFFFFF" aria-hidden="true">
      <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
        <path d="M1 5.2 2.4 3.8 4 5.4 7.6 1.8 9 3.2 4 8.2z" fill="#032170" />
      </svg>
    </Disc>
  );
}

export function RemoveDisc({
  size = 22,
  tone = 'grey',
}: {
  size?: number;
  tone?: 'grey' | 'white';
}) {
  const white = tone === 'white';
  return (
    <Disc
      $size={size}
      $bg={white ? '#FFFFFF' : 'var(--tm-border)'}
      aria-hidden="true"
    >
      <Dash
        $width={white ? 9 : 10}
        $color={white ? 'var(--tm-navy)' : 'var(--tm-text-2)'}
      />
    </Disc>
  );
}

export function MelonMark({ size = 28 }: { size?: number }) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 28 28"
      style={{ flex: '0 0 auto' }}
    >
      <circle cx="14" cy="14" r="14" fill="#032170" />
      <path d="M14 6a8 8 0 0 1 0 16z" fill="#BACDD1" />
      <circle cx="11" cy="14" r="1.6" fill="#FFFFFF" />
    </svg>
  );
}
